import { Card, VField, VInput, VTextarea } from "@/components/ui";
import type { RequesterDetails } from "@/domains/requests/api/types";

type StepRequesterProps = {
  value: RequesterDetails;
  onChange: (next: RequesterDetails) => void;
};

export function StepRequester({ value, onChange }: StepRequesterProps): React.JSX.Element {
  const patch = (partial: Partial<RequesterDetails>): void => onChange({ ...value, ...partial });

  return (
    <Card padding="lg" className="space-y-4">
      <div className="grid gap-4 md:grid-cols-2">
        <VField label="1. Achternaam" htmlFor="lastName" required>
          <VInput
            id="lastName"
            value={value.lastName}
            onChange={(e) => patch({ lastName: e.target.value })}
          />
        </VField>
        <VField label="2. Voornaam" htmlFor="firstName" required>
          <VInput
            id="firstName"
            value={value.firstName}
            onChange={(e) => patch({ firstName: e.target.value })}
          />
        </VField>
        <VField
          label="3. Mailadres"
          htmlFor="email"
          required
          hint="Het mailadres van de aanvrager"
        >
          <VInput
            id="email"
            type="email"
            value={value.email}
            onChange={(e) => patch({ email: e.target.value })}
          />
        </VField>
        <VField label="4. Telefoonnummer" htmlFor="phone" required>
          <VInput
            id="phone"
            value={value.phone}
            onChange={(e) => patch({ phone: e.target.value })}
          />
        </VField>
        <VField label="5. Dienst" htmlFor="service" required className="md:col-span-2">
          <VInput
            id="service"
            value={value.service}
            onChange={(e) => patch({ service: e.target.value })}
          />
        </VField>
        <VField
          label="6. Contactgegevens dienst"
          htmlFor="serviceContact"
          hint="Mailadres, telefoonnummer en/of teleformnummer waarop de dienst bereikbaar is."
          className="md:col-span-2"
        >
          <VTextarea
            id="serviceContact"
            rows={3}
            value={value.serviceContactDetails}
            onChange={(e) => patch({ serviceContactDetails: e.target.value })}
          />
        </VField>
      </div>
    </Card>
  );
}
